import React from 'react';

const HighlightEmails = ({ text }) => {

  function extractNameFromEmail(email) {
    // Split the email address by '@' to separate the username and domain
    const parts = email.split("@");

    // Get the username part
    const username = parts[0];

    // Split the username by '.' to separate the first and last names
    const names = username.split(".");

    // Join the names with a space to get the full name
    const firstName = names[0].charAt(0).toUpperCase() + names[0].slice(1);

    return "" +firstName;
  }
  // Regular expression to match email addresses
  const emailRegex = /[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}/g;

  const everyoneRegex = /%Everyone%/g; // Case-sensitive %Everyone%

  // Highlight email addresses and occurrences of "Everyone" in the text
  const highlightedText = text.replace(emailRegex, (match) => `<span title=${match} class="highlight">@${extractNameFromEmail(match)}</span>`)
    .replace(everyoneRegex, '<span class="highlight1">Everyone</span>');




  return (
    <span
      style={{
        width:"100%"
      }}
      className="faqs_items_cls items_cls font-size-new"
      dangerouslySetInnerHTML={{
        __html: highlightedText,
      }}
    ></span>
  );
};

export default HighlightEmails;
